import Icon from "assets/images/settings/feedbackNew.svg";
import { TextView } from "components";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "../../utils";
import Loader from "../CustomLoader";
import { useSelector } from "react-redux";

const CenterWrapper = styled.div`
  background-color: ${colors.white};
  padding: 2vw;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const FeedbackTitle = styled.div`
  display: flex;
  flex-direction: column;
`

const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

const Content = styled.div`
  width: 80%;
`;

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 67vh;
  border: 1px solid #E1E1E1;
  background-color: #F6F7F9;
  border-radius: 8px;
`;

export default function Feedback() {
  const [isLoaded, setIsLoaded] = useState(false); // Track if iframe is loaded

  const { userProfile } = useSelector((state) => state.userProfile);
  
  const { first_name, last_name,email } = userProfile;
  const iframeSrc = `https://link.iyuga.net/widget/form/7UqAPUhwMUZufxa6NKdf?first_name=${encodeURIComponent(
    first_name
  )}&last_name=${encodeURIComponent(last_name)}&email=${encodeURIComponent(email)}`;

  return (
    <CenterWrapper>
      <Row>
        <HeaderIcon src={Icon} />
        <FeedbackTitle>
          <TextView variant="title">Feedback</TextView>
          <TextView variant="subtitle">Your feedback means the world to us.</TextView>
        </FeedbackTitle>
      </Row>
      <Content>
        {!isLoaded && <Loader />}
        <StyledIframe
          src={iframeSrc}
          id="inline-7UqAPUhwMUZufxa6NKdf"
          title="Bug Feedback Form"
          onLoad={() => setIsLoaded(true)} // Set isLoaded to true when iframe loads
        ></StyledIframe>
      </Content>
    </CenterWrapper>
  );
}
